export default {
  cards: {
    map: {
      content: {
        title: "Peta Sebaran",
        showTitle: true,
        subtitle: "Jumlah Lembaga per Provinsi",
        showSubtitle: true,
        showIcon: false,
        info: "#### Menunjukan sebaran jumlah lembaga per provinsi",
        showInfo: true,
        showSaveAsImage: false,
        showTable: false,
        showDownloadTable: false,
      },
      warning: {
        title: "Jenjang Pendidik",
        showTitle: false,
        subtitle: "Jumlah Lembaga per Provinsi",
        showSubtitle: false,
        showIcon: false,
        info: "#### Menunjukan sebaran grafik jenjang pendidik",
        showInfo: true,
        showSaveAsImage: false,
        showTable: false,
        showDownloadTable: false,
      },
    },
    chart: {
      tendikAkreditasi: {
        queryName: "akreditas_lembaga",
        content: {
          title: "Total Institusi per Tingkat Akreditasi",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan grafik jumlah tendik menurut akreditasi",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            height: 440,
            bottom: 0,
          },
          chartOption: {
            tooltip: {
              trigger: "item",
            },
            series: [
              {
                name: "Jumlah Tenaga Kependidikan",
                type: "pie",
                label: {
                  formatter: "{b} ({d}%)",
                },
                radius: "75%",
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
                itemStyle: {
                  normal: {
                    color: (params) => {
                      const colorList = [
                        "#0C467B",
                        "#1879D3",
                        "#0085FF",
                        "#389BF6",
                        "#8EC9FF",
                      ];
                      return colorList[params.dataIndex];
                    },
                  },
                },
              },
            ],
          },
          columns: [
            {
              title: "Status Akreditas",
              dataIndex: "status_akreditas",
            },
            {
              title: "Jumlah Tenaga Kependidikan",
              dataIndex: "count",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
      jenjangPendidik: {
        queryName: "jenjangpendidik_filter_agama",
        content: {
          title: "Jumlah Institusi Pendidikan",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan grafik tenaga kependidikan berdasarkan jenjang pendidikan",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            height: 440,
            backgroundColor: "#389BF6",
            titleColor: "white",
          },
          chartOption: {
            textStyle: {
              color: "white",
            },
            grid: {
              top: 20,
              left: 60,
              right: 30,
              bottom: 0,
              containLabel: true,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            xAxis: {
              type: "value",
            },
            yAxis: {
              type: "category",
              data: [],
            },
            series: [
              {
                type: "bar",
                itemStyle: {
                  color: "white",
                },
              },
            ],
          },
          columns: [
            {
              title: "Jenjang Pendidikan",
              dataIndex: "lembaga_jenjangpendidikan",
            },
            {
              title: "Jumlah Tenaga Kependidikan",
              dataIndex: "count",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
    },
  },
};
